/* eslint-disable no-unused-vars */
// import { useChargepointList } from '../../../utils/queries/charger';
// import ChargerList from '../../Charger/ChargerList';
// import ChargersGrowth from '../../Charts/ChargersGrowth';
// import ChargersGrowthAnalytics from '../../Charts/ChargersGrowthAnalytics';
// import { useFetchCorporateChargersList } from '../../../utils/queries/corporateChargers';
import { useFetchCorporateByID } from '../../utils/queries/corporate';
import { useFetchCorporateChargersList } from '../../utils/queries/corporateChargers';
import CorporateChargersList from '../../components/Corporates/CorporateChargersList';
import { filter as lodashFilter, find } from 'lodash-es';
import { Button, Typography, Tabs, Badge } from 'antd';
import { useQueryParam, StringParam, withDefault } from 'use-query-params';
import { Link, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

const { Title } = Typography;

export default function CorporateChargers({ corporateId }) {
  const history = useHistory();
  const corporateData = {};
  const isLoading = false;
  // const { data: corporateData, isLoading } = useFetchCorporateByID(corporateId);
  const { data } = useFetchCorporateChargersList({
    filter: 'all',
    corporateId,
  });

  const allFilters = [
    { name: 'All', key: 'all', filter: {}, color: '#000000' },
    {
      name: 'Online',
      key: 'online',
      filter: { isOnline: true },
      color: '#52c41a',
    },
    {
      name: 'In use',
      key: 'inuse',
      filter: { 'CP_CONNECTORS.STATUS': 'Charging' },
      color: '#52c41a',
    },
    {
      name: 'Offline',
      key: 'offline',
      filter: { isOnline: false, isEnabled: true },
      color: 'red',
    },
    {
      name: 'Enabled',
      key: 'enabled',
      filter: { isEnabled: true },
      color: '#5e72e4',
    },
    {
      name: 'Disabled',
      key: 'disabled',
      filter: { isEnabled: false },
      color: 'grey',
    },
  ];
  // const [chargersData, setChargersData] = useState(null);

  // const [filter, setFilter] = useQueryParam(
  //   'filter',
  //   withDefault(StringParam, 'all'),
  // );
  const [filter, setFilter] = useState('all');

  // const {
  //   data = [],
  //   isLoading,
  //   isError,
  //   refetch,
  // } = useFetchCorporateChargersList({
  //   filter: 'all',
  // });
  const [chargersData, setChargersData] = useState(null);
  useEffect(() => {
    if (!chargersData) setChargersData(data);
  }, [chargersData, data]);

  const tabChangeHandler = (key) => {
    setFilter(key);
  };

  const filterChargersByStatus = (status) => {
    if (!data) return '';
    let cData = [];

    if (status === 'all') cData = data?.list;
    else if (status === 'online') {
      cData = lodashFilter(
        data?.list,
        (item) => item?.isOnline && item?.CONNECTORS[0]?.STATUS !== 'Charging',
      );
    } else if (status === 'inuse') {
      cData = lodashFilter(
        data?.list,
        (item) => item?.CONNECTORS[0]?.STATUS === 'Charging',
      );
    } else
      cData = lodashFilter(
        data?.list,
        find(allFilters, { key: status }).filter,
      );

    return cData;
  };

  const getChargersCountByStatus = (key) => {
    const cData = filterChargersByStatus(key);
    return cData ? cData?.length : '0';
  };

  const getBadgeColourByStatus = (status) =>
    find(allFilters, { key: status }).color;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <LeftOutlined
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => history.goBack()}
          />
          <Title level={2} style={{ margin: '0px' }}>
            Chargers
            <span style={{ color: '#2375b8', marginLeft: 5 }}>
              {corporateData?.data?.CORPORATE_NAME}
            </span>
          </Title>
        </div>

        {/* <Link
          to={`/corporates/chargers/create/${corporateId}`}
          className="block mb-4"
        >
          <Button type="primary" size="large">
            Add New Charger
          </Button>
        </Link> */}
      </div>

      <Tabs
        activeKey={filter}
        onTabClick={(key) => {
          tabChangeHandler(key);
        }}
        className="w-full"
      >
        {allFilters.map(({ name, key }) => (
          <TabPane
            tab={
              <span>
                {name}&nbsp;
                <Badge
                  style={{
                    backgroundColor: getBadgeColourByStatus(key),
                    fontSize: '18px',
                  }}
                  count={getChargersCountByStatus(key) || 0}
                  overflowCount={999}
                />
              </span>
            }
            key={key}
          >
            <CorporateChargersList
              showMap={key === 'all'}
              corporateId={corporateId}
              data={filterChargersByStatus(key)}
              // data={chargersData?.list}
              isLoading={isLoading}
              // isError={isError}
            />
            {/* <ChargerList
              data={filterChargersByStatus(key)}
              isLoading={isLoading}
              isError={isError}
            /> */}
          </TabPane>
        ))}
        {/* <TabPane tab="Analytics" key="analytics">
         <ChargersGrowthAnalytics chargers={data?.list} /> 
        </TabPane> */}
      </Tabs>
    </>
  );
}
